import React from 'react';
import OrganizationLink from 'src/common/OrganizationLink';

import { Integration } from 'src/common/interfaces/integration.interface';

interface Props {
  integration: Integration;
}

const PaywallDetail = ({
  integration: {  name, paywall_work_copy, paywall_type },
}: Props) => {


  return (
    <div className='flex flex-col mt-4 space-y-6 text-bedrock-black'>
      <h1 className='text-bedrock-h1 font-brand-serif capitalize'>{name}</h1>

      <div className='flex flex-col space-y-6 max-w-[600px]'>
        <div className='col-span-5 flex flex-col space-y-2'>
          <h2 className='text-bedrock-p-strong'>How does it work?</h2>
          {typeof paywall_work_copy === 'string' ? (
            <p className='text-bedrock-p'>{paywall_work_copy}</p>
          ) : (
            paywall_work_copy
          )}
        </div>
       
          <div className='space-y-6'>
          
          <OrganizationLink to='/billing'>
              <button className='btn-bedrock-primary self-start flex space-x-1'>
                <span>{paywall_type==='enterprise'?'Upgrade to Scale':'Upgrade to Grow'}</span>
              </button>
          </OrganizationLink>
          </div>
      </div>
    </div>
  );
};

export default PaywallDetail;
